/**
 * Distinct raw values found in a column, sourced from the upload's sample
 * rows rather than the preview response — see this feature's
 * `derive-interpreted-rows.ts` header comment / findings.md's "period_label_map
 * preview rows are empty..." gotcha for why.
 *
 * `fullFileDistinctValues` (the upload response's `columnDistinctValues`,
 * see `AvailabilityImportUploadResponseSchema`) takes precedence when it
 * contains the column: `rows` (sampleRows) is capped at SAMPLE_ROWS_LIMIT
 * (20) server-side, so a distinct phrase that only appears later in the
 * file would otherwise never surface in the period-label mapping table.
 */
export function getDistinctColumnValues(
  rows: Record<string, string>[],
  column: string | null,
  fullFileDistinctValues?: Record<string, string[]>,
): string[] {
  if (!column) return [];
  const fromFullFile = fullFileDistinctValues?.[column];
  if (fromFullFile) return fromFullFile;
  const seen = new Set<string>();
  for (const row of rows) {
    const raw = row[column]?.trim();
    if (raw) seen.add(raw);
  }
  return [...seen];
}
